import createRequestSaga from "../../../common/saga/createRequestSaga";
import { takeEvery } from "redux-saga/effects";
import * as bookUpdateApi from "../api/bookUpdateApi";
import { BOOKUPDATE, BOOKUPDATE_BATCH } from "../actionCreators";

const BookUpdateSaga = createRequestSaga(
  BOOKUPDATE,
  bookUpdateApi.bookUpdateApi
);
const BookUpdateBatchSaga = createRequestSaga(
  BOOKUPDATE_BATCH,
  bookUpdateApi.bookUpdateBatchApi
);
export function* bookUpdateSaga() {
  yield takeEvery(BOOKUPDATE, BookUpdateSaga);
  yield takeEvery(BOOKUPDATE_BATCH, BookUpdateBatchSaga);
}
